// extracted by mini-css-extract-plugin
export default {"body":"Error500Page_body__vd8MW"};